<template>
  <div style="position: relative">
    <v-premium-plan-popup
      v-if="$store.getters.getPackage != 'premium'"
      :show-all="false"
      margin-top="65"
      style="border-radius: 5px"
    ></v-premium-plan-popup>
    <v-container>
      <div>
        <h3 class="headline">{{ $t('Cart Summary') }}</h3>

        <v-layout row wrap>
          <v-flex class="mb-4" sm12 xs12>
            <div>
              <date-filter
                v-model="selectedDate"
                :default-filter="'today'"
                @changeDate="onDateChanged"
              ></date-filter>
            </div>

            <v-divider class="mt-3"></v-divider>
          </v-flex>
          <v-flex sm6 xs12>
            <div
              class="nav nav-tabs"
              style="margin-bottom: 10px; overflow-x: auto; white-space: nowrap"
            >
              <v-btn
                :color="filterApp != 'all' ? 'grey' : 'primary'"
                :outline="filterApp != 'all'"
                class="ma-1"
                depressed
                small
                @click="filterApp = 'all'"
                >{{ $t('All') }} {{ `(${rawusers.length})` }}
              </v-btn>
              <v-btn
                :color="filterApp != 'facebook' ? 'grey' : 'primary'"
                :outline="filterApp != 'facebook'"
                class="ma-1"
                depressed
                small
                @click="filterApp = 'facebook'"
                >{{ $t('facebook') }} {{ `(${facebooklength})` }}
              </v-btn>
              <v-btn
                :color="filterApp != 'line' ? 'grey' : 'primary'"
                :outline="filterApp != 'line'"
                class="ma-1"
                depressed
                small
                @click="filterApp = 'line'"
                >{{ $t('line') }} {{ `(${linelength})` }}
              </v-btn>
            </div>
          </v-flex>
          <v-flex class="text-xs-right" sm6 xs12>
            <v-btn
              :disabled="selectedUsers.length == 0"
              class="ma-0 mb-1"
              color="primary"
              outline
              @click="onDeleteAllInCart"
            >
              <v-icon class="mr-1">remove_shopping_cart</v-icon>
              {{ $t('Clear cart') }}
            </v-btn>
            <v-btn class="ma-0 mb-1" color="grey" outline @click="exportCartSummary">
              <em class="fas fa-file-export mr-1" />
              {{ $t('export') }}
            </v-btn>
            <v-btn class="ma-0 mb-1 ml-2" color="primary" icon outline @click="getUser">
              <v-icon>refresh</v-icon>
            </v-btn>
          </v-flex>
          <v-flex sm12 xs12>
            <div>
              <div
                v-if="isCentralLive"
                class="nav nav-tabs"
                style="margin-bottom: 10px; overflow-x: auto; white-space: nowrap"
              >
                <v-btn
                  :color="filterCategoryStatus != 'all' ? 'grey' : 'primary'"
                  :outline="filterCategoryStatus != 'all'"
                  class="ma-1"
                  depressed
                  small
                  @click="filterCategoryStatus = 'all'"
                  >{{ $t('All') }}
                </v-btn>
                <v-btn
                  v-for="(category, k) in categories"
                  :key="k"
                  :color="filterCategoryStatus != category ? 'grey' : 'primary'"
                  :outline="filterCategoryStatus != category"
                  class="ma-1"
                  depressed
                  small
                  @click="filterCategoryStatus = category"
                  >{{ category }}
                </v-btn>
              </div>
            </div>
          </v-flex>
          <v-flex xs6>
            <div class="form-control">
              <input
                v-model="filter.fullname"
                placeholder="ค้นหา"
                type="text"
                @keyup.enter="onSearch"
              />
            </div>
          </v-flex>
          <v-flex>
            <v-btn color="primary" icon outline @click="onSearch">
              <v-icon>search</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>

        <v-data-table
          v-model="selectedUsers"
          :headers="headers"
          :items="filteredUser"
          :loading="loading"
          :pagination.sync="pagination"
          class="elevation-1 scgallrenttable"
          expand
          select-all
        >
          <template #items="props">
            <tr style="cursor: pointer">
              <td style="width: 1%">
                <v-checkbox
                  v-model="props.selected"
                  color="primary"
                  hide-details
                  primary
                ></v-checkbox>
              </td>
              <td>
                <v-btn icon @click="deleteItem(props.item)">
                  <v-icon color="grey">delete</v-icon>
                </v-btn>
              </td>
              <td class="text-xs-center" @click="showCartDialog(props.item.id)">
                <v-avatar size="30">
                  <img
                    v-if="props.item.profile_pic"
                    :src="props.item.profile_pic"
                    height="30"
                    width="30"
                    @error="onFailLoad"
                  />
                  <img
                    v-else
                    :alt="props.item.name"
                    :src="'/static/img/assets/livechat/profile.png'"
                    height="30"
                    width="30"
                  />
                </v-avatar>
              </td>
              <td class="text-xs-left" @click="showCartDialog(props.item.id)">
                {{ props.item.name }}
              </td>
              <template v-if="selectedBot.theme === 'scgdistribution'">
                <td class="text-xs-left" @click="showCartDialog(props.item.id)">
                  <edit-customer-value
                    v-model="props.item['cardnumber']"
                    :placeholder="$t('Card number')"
                    :type="'number'"
                    :userid="props.item.id"
                    @onEdit="putusercardnumber('cardnumber', $event, props.item)"
                  >
                    <customer-item-value :value="props.item['cardnumber']"
                      >{{ props.item.cardnumber }}
                    </customer-item-value>
                  </edit-customer-value>
                </td>
                <td class="text-xs-left" @click="showCartDialog(props.item.id)">
                  <edit-customer-value
                    v-model="props.item['realname']"
                    :placeholder="$t('realname')"
                    :userid="props.item.id"
                    @onEdit="putuserrealname('realname', $event, props.item)"
                  >
                    <customer-item-value :value="props.item['realname']"
                      >{{ props.item.realname }}
                    </customer-item-value>
                  </edit-customer-value>
                </td>
                <td class="text-xs-left" @click="showCartDialog(props.item.id)">
                  <edit-customer-value
                    v-model="props.item['address']"
                    :placeholder="$t('Province')"
                    :userid="props.item.id"
                    @onEdit="onEditAddress('address', $event, props.item)"
                  >
                    <customer-item-value :value="props.item['address']"
                      >{{ props.item.address }}
                    </customer-item-value>
                  </edit-customer-value>
                </td>
              </template>

              <td class="text-xs-center" @click="showCartDialog(props.item.id)">
                {{ props.item.productname ? props.item.productname : '-' }}
              </td>
              <td class="text-xs-center" @click="showCartDialog(props.item.id)">
                {{ props.item.quantity | numberFormat }}
              </td>
              <!-- <td @click="showCartDialog(props.item.id)" class="text-xs-center">
                {{ props.item.cartprice | numberFormat }}
              </td> -->
              <td class="text-xs-center" @click="showCartDialog(props.item.id)">
                {{ props.item.timestamp | DateFormat('DD/MM/YYYY HH:mm') }}
              </td>
              <td class="text-xs-center" @click="showCartDialog(props.item.id)">
                <v-btn
                  :dark="props.item.inboxurl ? true : false"
                  :disabled="!props.item.inboxurl"
                  color="#3b5998"
                  depressed
                  round
                  small
                  target="_blank"
                  @click.stop="viewInbox(props.item.inboxurl)"
                >
                  <em class="fab fa-facebook-square mr-1" />
                  {{ $t('View inbox') }}
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </v-container>
    <div>
      <v-dialog v-model="showCart" persistent width="660">
        <v-card>
          <div class="text-xs-right">
            <v-btn icon small @click="close">
              <v-icon small>close</v-icon>
            </v-btn>
          </div>
          <div>
            <v-layout>
              <v-flex class="text-xs-left my-2 ma-2">
                <span>{{ $t('Total') }}</span>
                <span class="primary--text" style="font-weight: 500">
                  {{ cartitem.total | numberFormat }}
                </span>
              </v-flex>
              <v-flex class="text-xs-right">
                <v-btn color="primary" outline @click="onDeleteSelected">
                  <v-icon class="mr-1">remove_shopping_cart</v-icon>
                  {{ $t('Clear cart') }}
                </v-btn>
              </v-flex>
            </v-layout>
            <v-data-table
              :headers="cartheaders"
              :items="cartitem.cartarray"
              :loading="cartloading"
              :pagination.sync="pagination"
              class="elevation-1 scgallrenttable"
              expand
            >
              <template #items="props">
                <tr>
                  <td class="text-xs-center">
                    <v-avatar size="45" tile>
                      <img
                        v-if="props.item.photourl"
                        :alt="props.item.name"
                        :src="props.item.photourl.split(';;')[0]"
                        height="30"
                        width="30"
                        @error="onFailLoad"
                      />
                      <img
                        v-else
                        :alt="props.item.name"
                        :src="'/static/img/assets/livechat/profile.png'"
                        height="30"
                        width="30"
                      />
                    </v-avatar>
                  </td>
                  <td class="text-xs-center">{{ props.item.name }}</td>
                  <td class="text-xs-center">{{ props.item.option }}</td>
                  <td class="text-xs-center">{{ props.item.quantity | numberFormat }}</td>
                </tr>
              </template>
            </v-data-table>
          </div>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import moment from 'moment'
import DateFilter from '@/components/view/dashboard/DateFilter'
import CustomerItemValue from '@/components/view/dashboard/customer/CustomerItemValue.vue'
import EditCustomerValue from '@/components/view/dashboard/EditCustomerValueDialog'

export default {
  components: {
    DateFilter,
    CustomerItemValue,
    EditCustomerValue
  },
  data() {
    return {
      filterCategoryStatus: 'all',
      selectedDate: {
        start: moment().format('YYYY-MM-DD') + ' 00:00',
        end: moment().format('YYYY-MM-DD') + ' 23:59'
      },
      cartitem: [],
      search: '',
      filterApp: 'all',
      showCart: false,
      pagination: { sortBy: 'none', descending: true, rowsPerPage: 25 },

      cartheaders: [
        {
          text: '',
          value: 'photourl',
          align: 'center',
          width: '3%'
        },
        {
          text: this.$t('name'),
          value: 'name',
          align: 'center',
          width: '3%'
        },
        {
          text: this.$t('option'),
          value: 'option',
          align: 'center',
          width: '1%'
        },
        {
          text: this.$t('Quantity'),
          value: 'quantity',
          align: 'center',
          width: '1%'
        }
        // {
        //   text: this.$t('Price'),
        //   value: 'discountprice',
        //   align: 'center',
        //   width: '2%'
        // }
      ],
      loading: false,
      cartloading: false,
      rawusers: [],
      products: [],
      selectedUsers: [],
      selectedUser: null,
      filter: { fullname: '' }
    }
  },
  computed: {
    headers() {
      if (this.selectedBot.theme === 'scgdistribution') {
        return [
          {
            text: '',
            value: '',
            align: 'center',
            width: '3%',
            sortable: false
          },
          {
            text: '',
            value: 'photourl',
            align: 'center',
            width: '3%',
            sortable: false
          },
          {
            text: this.$t('Name'),
            value: 'name',
            align: 'left',
            width: 'auto'
          },
          {
            text: this.$t('Shop code'),
            value: 'cardnumber',
            align: 'left',
            width: 'auto'
          },
          {
            text: this.$t('Shop name'),
            value: 'realname',
            align: 'left',
            width: 'auto'
          },
          {
            text: this.$t('Province'),
            value: 'province',
            align: 'left',
            width: 'auto'
          },

          {
            text: this.$t('Product name'),
            value: 'productname',
            align: 'center',
            width: '1%'
          },
          {
            text: this.$t('Quantity'),
            value: 'quantity',
            align: 'center',
            width: '1%'
          },

          // {
          //   text: this.$t('Cart price'),
          //   value: 'cartprice',
          //   align: 'center',
          //   width: '1%',
          // },
          {
            text: this.$t('Date') + ' / ' + this.$t('Time'),
            value: 'timestamp',
            align: 'center',
            width: '1%'
          },
          {
            text: this.$t('Inbox'),
            value: 'inboxurl',
            align: 'center',
            width: '2%'
          }
        ]
      } else {
        return []
      }
    },
    categories() {
      var uniq = [...new Set(this.rawusers.map((el) => el.categoryname))]
      return uniq
    },
    ...mapGetters(['selectedBot']),
    facebooklength() {
      return this.rawusers.filter((el) => el.app == 'facebook').length
    },
    linelength() {
      return this.rawusers.filter((el) => el.app == 'line').length
    },
    isCentralLive() {
      return this.$store.state.centralPage.includes(this.selectedBot.pageid)
    },
    filteredUser() {
      var result
      var user = this.rawusers
      if (this.search) {
        user = user.filter((val) => val.name.toLowerCase().includes(this.search.toLowerCase()))
      }
      result = user.filter((el) => {
        if (this.filterApp != 'all') {
          return el.app == this.filterApp
        } else {
          return true
        }
      })
      if (this.filterCategoryStatus != 'all') {
        result = result.filter((el) => el.categoryname == this.filterCategoryStatus)
      }
      return result
    }
  },
  mounted() {
    this.getUser()
  },
  methods: {
    deleteItem(item) {
      this.$swal
        .fire({
          text: 'ต้องการลบรายการนี้ ?',
          showCancelButton: true
        })
        .then((result) => {
          if (result.value) {
            this.loading = true
            var data = {
              pageid: this.selectedBot.pageid,
              cartid: item.cartid
            }
            console.log(item)
            api.deletecmsviewcartbyid(data, () => {
              this.loading = false
              this.getUser()
            })
          }
        })
    },
    onSearch() {
      this.getUser({ fullname: this.filter.fullname })
    },
    onEditAddress(type, payload, item) {
      var vm = this
      vm.$store.dispatch('loading')

      var data = {
        pageid: this.selectedBot.pageid,
        usersid: payload.usersid,
        address: payload.customer_value
      }
      api.saveUserAddress(data, function (error) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }

        vm.$store.dispatch('loading')
        this.$set(item, type, payload.customer_value)
      })
    },
    putuserrealname(type, payload, item) {
      var vm = this

      this.$set(item, type, payload.customer_value)

      vm.$store.dispatch('loading')
      var data = {
        body: {
          usersid: item.id,
          realname: payload.customer_value
        },
        params: {
          pageid: this.selectedBot.pageid
        }
      }
      api.putuserrealname(data, function (error) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
        vm.getUser()
        vm.$forceUpdate()
      })
    },
    putusercardnumber(type, payload, item) {
      var vm = this
      this.$set(item, type, payload.customer_value)

      vm.$store.dispatch('loading')
      var data = {
        body: {
          usersid: item.id,
          cardnumber: payload.customer_value
        },
        params: {
          pageid: this.selectedBot.pageid
        }
      }
      api.putusercardnumber(data, function (error) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
        vm.getUser()
        vm.$forceUpdate()
      })
    },
    async onDeleteSelected() {
      if (this.selectedUser) {
        this.selectedUsers.push(this.selectedUser)
        await this.onDeleteAllInCart()
        this.showCart = false
      }
    },
    async onDeleteAllInCart() {
      var result = await this.$swal.fire({
        title: this.$t('Do you want to clear cart'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })

      if (result.value) {
        var userid = this.selectedUsers.map((el) => {
          return el.id
        })
        this.loading = true
        await this.deleteAllInCart(userid)
        this.rawusers = this.rawusers.filter((el) => !userid.includes(el.id))

        this.loading = false
      }
    },
    deleteAllInCart(userid) {
      return new Promise((resolve, reject) => {
        if (!this.selectedUsers || this.selectedUsers.length == 0) {
          reject()
        }
        var data = {
          pageid: this.selectedBot.pageid,
          userid_arr: userid
        }
        api.deleteAllInCart(data, (error, response) => {
          if (error) {
            console.error(error)
          }
          resolve(response)
        })
      })
    },
    onDateChanged() {
      this.filter.fullname = ''
      this.getUser()
    },
    close() {
      this.cartitem = []
      this.showCart = false
    },
    viewInbox(link) {
      window.open(link, '_blank')
    },
    showCartDialog(id) {
      this.showCart = id

      var user = this.rawusers.find((el) => {
        return el.id == id
      })
      this.selectedUser = user
      this.getCart(id)
    },
    getCart(id) {
      this.cartloading = true
      api.getusercart({ pageid: this.selectedBot.pageid, userid: id }, (err, response) => {
        this.cartloading = false
        if (response && response.cartarray) {
          this.cartitem = response
        }
      })
    },
    onFailLoad: function (e) {
      // console.log(e)
      e.target.src = '/static/img/assets/livechat/profile.png'
      // this.$set(this.user, 'profile_pic', '/static/img/assets/livechat/profile.png')
    },
    getUser(search) {
      this.loading = true
      var data = {
        pageid: this.selectedBot.pageid,
        startdate: this.selectedDate.start,
        enddate: this.selectedDate.end
      }

      if (search && search.fullname) {
        Object.assign(data, {
          fullname: search.fullname
        })
      }
      api.getcmsviewcarts(data, (err, response) => {
        this.loading = false
        if (response.data) {
          this.rawusers = response.data
        } else {
          this.rawusers = []
        }
      })
    },
    exportCartSummary: function () {
      let vm = this
      if (vm.loading) {
        return false
      }
      var csvdata =
        'Shop code,Shop name,Province,Name,Product name,Quantity,Unit,Price,Discount price,Date&Time\r\n'

      this.filteredUser.forEach((el) => {
        csvdata += `${el.cardnumber ? el.cardnumber : '-'},${el.realname ? el.realname : '-'},${
          el.address ? el.address.replaceAll(',', '') : '-'
        },${el.name ? el.name : '-'},${el.productname ? el.productname : '-'},${
          el.quantity ? el.quantity : '-'
        },${el.option ? el.option : '-'},${el.price ? el.price : '-'},${
          el.discountprice ? el.discountprice : '-'
        },${el.timestamp ? moment(el.timestamp).format('DD/MM/YYYY HH:mm') : '-'}\r\n`
      })
      vm.exportCsv(csvdata, 'cartsummary')
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/CartSummaryScgdistribute.vue